class SlideCartNotification {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      const originalCartNotificationProto = Object.getPrototypeOf(document.querySelector('cart-notification'));
      const originalOpen = originalCartNotificationProto.open;
      const originalClose = originalCartNotificationProto.close;

      originalCartNotificationProto.open = this.overrideOpen(originalOpen);
      originalCartNotificationProto.close = this.overrideClose(originalClose);
    });
  }

  overrideOpen(originalOpen) {
    return function() {
      originalOpen.call(this);

      const notification = document.getElementById('cart-notification');

      let slideOutTimeoutId;
      const autoDismissTimeoutId = setTimeout(() => {
        notification.classList.add('slide-out-right');
        slideOutTimeoutId = setTimeout(() => {
          this.close();
          notification.classList.remove('slide-out-right');
        }, 300);
      }, 7000);

      this._autoDismissTimeoutId = autoDismissTimeoutId;
      this._slideOutTimeoutId = slideOutTimeoutId;

      const handleBackgroundClick = (evt) => {
        const target = evt.target;
        if (target === notification || target.classList.contains('cart-notification-wrapper')) {
          clearTimeout(this._autoDismissTimeoutId);
          clearTimeout(this._slideOutTimeoutId);
          notification.classList.add('slide-out-right');
          setTimeout(() => {
            this.close();
            notification.classList.remove('slide-out-right');
            notification.removeEventListener('click', handleBackgroundClick);
          }, 300);
        }
      };

      notification.addEventListener('click', handleBackgroundClick);
    };
  }

  overrideClose(originalClose) {
    return function() {
      const notification = document.getElementById('cart-notification');
      if (notification.classList.contains('slide-out-right')) {
        notification.classList.remove('slide-out-right');
      }
      originalClose.call(this);
    }
  }
}

new SlideCartNotification();